import { Tabs, Radio } from 'antd/lib'
import styled from 'styled-components'
import { Fonts } from '@nv/react-commons/src/Themes'
import { Dropdown, Menu, Icon, DatePicker, Spin } from '@nv/react-commons/src/Components'
import { faExclamationCircle } from '@fa-pro-solid/faExclamationCircle'
import { Drawer } from 'antd'

import { Colors } from 'themes'
import { SmallP, Text } from 'components/Text'
import { RadioGroup } from 'components/RadioGroup'
import { SearchInput } from 'components/SearchInput'
import { CenterText } from 'components/CenterText'
import { Button } from 'components/Button'
import SubMenu from 'antd/lib/menu/SubMenu'
import { StyledDropdownButton } from 'containers/FPLOrderRequestList/OrderRequestTable'

import { Col, Row } from 'antd'
import { DropZone } from 'containers/FPLAllOrders/DropZone'
import { Checkbox } from '@nv/react-commons/src/Components'
import { IconButton } from 'components/IconButton'

const { RangePicker } = DatePicker

export const TableWrapper = styled.div`
  position: relative;
  overflow: auto;
  flex: 1 1;
`

export const StyledTabWrapper = styled.div`
  min-width: 100%;
  flex: 1 1;
  display: flex;
  flex-direction: column;
`

export const StyledFlexRow = styled.div`
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const StyledFiltersRow = styled.div`
  z-index: 1;
  background: white;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.08);
  margin: 0px;
  padding: 8px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const StyledFlex = styled.div`
  display: flex;
  align-items: center;
`

export const StyledDropdownSubMenu = styled(SubMenu)`
  && {
    .ant-dropdown-menu-submenu-arrow {
      top: 24px;
      right: 0;
    }

    &.ant-dropdown-menu-submenu-disabled {
      background: ${Colors.balanceGreyLight};
      .ant-dropdown-menu-submenu-arrow {
        i {
          background: ${Colors.balanceGreyLight};
        }
      }
      .ant-dropdown-menu-submenu-title {
        background: ${Colors.balanceGreyLight};
      }
    }
  }
`

export const StyledDropdownMenuItem = styled(Menu.Item)`
  && {
    padding: 5px 12px;
    &.ant-dropdown-menu-item-disabled {
      background: ${Colors.balanceGreyLight};
      .ant-dropdown-menu-title {
        background: ${Colors.balanceGreyLight};
      }
    }
  }
`

export const StyledDropdownMenu = styled(Menu)`
  && {
    padding: 4px 0;
    ${({ width }) => width && `max-width: ${width}px`};
  }
`

export const StyledParcelCount = styled(Text)`
  && {
    font-size: 14px;
    color: '#5c6166';
  }
`

export const StyledDropdown = styled(Dropdown)`
  && {
    height: 40px;
    width: 100px;
  }
`

export const StyledTabs = styled(Tabs)`
  && {
    display: flex;
    flex-grow: 1;
    flex-flow: column;
    .ant-tabs-bar.ant-tabs-top-bar {
      background: white;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.08);
      margin: 0px;
      padding: 0 24px;
    }
    .ant-tabs-content.ant-tabs-content-no-animated.ant-tabs-top-content {
      display: flex;
      flex-grow: 1;
      flex-flow: column;
    }
    .ant-tabs-tabpane.ant-tabs-tabpane-active {
      display: flex;
      flex-grow: 1;
      flex-flow: column;
    }
  }
`

export const StyledSearchInput = styled(SearchInput)`
  && {
    align-self: flex-end;
    width: 350px;
    border: 1px solid ${Colors.alto};
    border-radius: 4px;
    input.ant-input {
      background-color: white;
    }
  }
`
export const StyledIcon = styled(Icon).attrs({
  icon: faExclamationCircle,
  color: '5C6166'
})`
  && {
    margin-left: 10px;
    font-size: 18px;
  }
`

export const StyledNoRowsText = styled(CenterText).attrs({
  type: 'bold'
})`
  && {
    margin-top: 24px;
  }
`

export const GroupButtonWrapper = styled(RadioGroup)`
  display: flex !important;
`

export const OptionButton = styled(Radio.Button)`
  ${({ fullWidth }) => {
    if (fullWidth) {
      return 'width: 100%;'
    }
  }}

  ${({ isCustom }) => {
    if (isCustom) {
      return `
        &.ant-radio-button-wrapper {
          height: 40px;
          display: flex;
          align-items: center;
        }
      `
    }
  }}

  ${({ lastChild }) => {
    if (lastChild) {
      return `
        &.ant-radio-button-wrapper:first-child {
          border-right: 1px solid #d9d9d9;
          border-radius: 0 4px 4px 0;
          border-left: none;
        }
      `
    }
  }}

  text-align: center;

  &:hover {
    color: ${Colors.darkGrey};
  }

  &&.ant-radio-button-wrapper-checked {
    background: ${Colors.greyishBrownTwo};
    color: ${Colors.white};
    border-color: ${Colors.greyishBrownTwo} !important;
    box-shadow: -1px 0 0 0 ${Colors.greyishBrownTwo};

    &:hover {
      border-color: ${Colors.greyishBrownTwo} !important;
      color: ${Colors.white};
      box-shadow: -1px 0 0 0 ${Colors.greyishBrownTwo};
    }
  }
`

export const TextWrapper = styled.div`
  padding-right: 8px;
`

export const StyledDateRangeFilterMenuItem = styled(Menu.Item)`
  padding: 8px 0;
`

export const StyledMenuItemLabel = styled.span`
  max-width: 128px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const DescriptionStyled = styled(Text)`
  white-space: pre-line;
  color: ${Colors.pinkishGrey};
  line-height: 18px;
  font-size: 12px;
`

export const StyledOtherDropdown = styled(Dropdown)`
  && {
    color: ${props => props.color};
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const StyledDateRangeDropdown = styled(RangePicker)`
  && {
    width: 242px;
    visibility: hidden;
    position: absolute;
    left: 0;
    top: 46px;

    #rangePickerCalendarContainer {
      .ant-calendar-input-wrap {
        height: 0;
        padding: 0;
        border: none;
      }
    }
  }
`

export const StyledButton = styled.div`
  && {
    height: 40px;
    position: relative;
    text-transform: capitalize;
    letter-spacing: normal;
    ${Fonts.style.regular};

    .ant-calendar-input-wrap {
      height: 0;
      padding: 0;
      border: none;
      display: none;
    }

    .ant-calendar-range-middle {
      display: none;
    }
  }
`

export const MenuMultipleSelectStyled = styled(Menu)`
  box-shadow: 0 2px 8px rgb(0 0 0 / 15%) !important;

  .ant-menu-item {
    height: 36px !important;
    line-height: 36px !important;
  }

  .ant-menu-item-selected {
    background-color: #fff !important;
  }
`

export const StyledDownloadCSVButton = styled(Button)`
  text-transform: none !important;
  && {
    height: 40px;
  }
`

export const StyledMenuItem = styled(Menu.Item)`
  min-height: 56px;
`

export const CustomIcon = styled(Icon)`
  ${({ marginleft, fontSize }) => {
    return `
      margin-left: ${marginleft || 0}px;
      font-size: ${fontSize || 14}px;
    `
  }}
`

export const SmallPLineBreak = styled(SmallP)`
  white-space: pre-line;
`

export const StyledFilterDropdown = styled(StyledDropdownButton)`
  min-height: 40px;
  border-color: #d9d9d9 !important;
  border-radius: 4px !important;
  font-size: 12px !important;
  display: flex;
  align-items: center;
`

export const StyledSpin = styled(Spin)`
  && {
    display: block;
  }
`

export const StyledWrapper = styled.div`
  height: 100%;
`

export const StyledText = styled(Text)`
  && {
    font-size: 14px;
    line-height: 18px;
  }
`

export const StyledReturnOptionDescription = styled(Text)`
  && {
    margin-top: 4px;
    font-size: 14px;
    color: ${Colors.disabled};
  }
`

export const StyledRequestDetailsWrapper = styled.div`
  width: 100%;
  padding: 8px 16px;
  background-color: ${props => (props.disabled ? Colors.akiraGrey7 : Colors.white)};
  border-radius: 4px;

  a {
    display: block;
  }
`

export const StyledPaymentDetailsBox = styled(StyledRequestDetailsWrapper)`
  && {
    display: flex;
    padding: 16px 16px 24px 16px;
  }
`

export const StyledPaymentDetailsIcon = styled(Icon)`
  && {
    color: ${Colors.disabled};
    width: 24px;
    height: 24px;
  }
`

export const StyledRadioGroupWrapper = styled.div`
  .ant-radio-group {
    width: 100%;
  }
  .ant-radio-wrapper {
    display: flex;
    white-space: normal;
    line-height: 16px;
  }
  .ant-radio-disabled + span {
    color: ${Colors.greyishBrown};
  }
`

export const StyledActionsWrapper = styled.div`
  display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 0 20px 16px 20px;
`

export const EditAddressButton = styled(Button)`
  position: absolute !important;
  right: 0;
  top: 0;
  min-width: 24px !important;
  height: 24px !important;
  padding: 0 !important;

  &:hover {
    img {
      filter: brightness(0) saturate(100%) invert(10%) sepia(100%) saturate(10000%) hue-rotate(26deg);
    }
  }
`

export const StyledDot = styled(Text)`
  && {
    line-height: 18px;
    margin-right: 8px;
  }
`

export const StyledDetailLabel = styled(StyledText).attrs({
  type: 'bold'
})`
  && {
    flex: 0.8;
    color: ${Colors.pinkishGrey};
  }
`

export const StyledDetailValue = styled(StyledText)`
  && {
    flex: 2;
  }
`

export const StyledDisclaimerWrapper = styled.div`
  padding: 12px 16px;
  border: 1px solid ${Colors.paleGrey};
  border-radius: 4px;
`

export const StyledImage = styled.img`
  height: 150px;
  object-fit: cover;
`

export const StyledResultPanelWrapper = styled.div`
  margin: 0 77px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`

export const StyledTitleWrapper = styled.div`
  display: flex;
  gap: 4px;
  font-weight: bold
`

export const RelabelWrapper = styled.div``

export const RelabelCard = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  height: 100%;
`

export const ListItem = styled.ul`
  list-style-type: decimal;
  padding: 0 24px;
  li {
    padding-top: 12px;
  }
`

export const ListWrapper = styled.div`
  width: 100%;
  height: 100%;
`

export const HeaderList = styled.div`
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  font-weight: bold;
  background-color: #f8f8f8;
  padding: 6px 12px;
`

export const HeaderBody = styled.div`
  max-height: calc(100% - 82px);
  height: calc(100% - 82px);
  overflow: auto;
  padding: 6px 12px;
  background-color: white;
`

export const FooterList = styled(Button)`
  &&& {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: normal;
    svg {
      margin-right: 0;
    }
    text-transform: none;
  }
  width: 100%;
`

export const CustomLinkWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  a {
    margin: 0;
  }
`

export const RowFixedSize = styled(Row)`
  &&& {
    height: calc(100vh - 378px);
  }
`

export const ColFixedSize = styled(Col)`
  &&& {
    height: 100%;
  }
`

export const BlockFixedSize = styled.div`
  height: calc(100% - 16px);
`

export const RelabelDropZone = styled(DropZone)`
  &&& {
    height: 65%;
  }
`

export const RelativeWrapper = styled.div`
  position: relative;
  height: 100%;
`

export const LeftZone = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`

export const RightZone = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  height: ${props => props.height};
  display: flex;
  align-items: flex-end;
`

export const StyledFlexBetween = styled(StyledFlex)`
  justify-content: space-between;
`

export const StyledCheckbox = styled(Checkbox)`
  &&& {
    display: flex;
    align-items: flex-end;
    span {
      color: ${props => (props.disabled ? Colors.balanceTxtLight : 'inherit')};
    }
  }
`

export const StyledPointerText = styled(Text)`
  cursor: pointer;
`

export const StyledReturnOptionWarning = styled(Text)`
  && {
    margin-top: 4px;
    font-size: 13px;
    color: ${Colors.cherryRed};
    padding-left: 24px;
  }
`

export const StyledLinkSpan = styled.span`
  color: ${Colors.cherryRed};
  padding-left: 4px;
  cursor: pointer;
`

export const StyledSpanText = styled.span`
  color: ${Colors.greyishBrown};
`

export const StyledCustomActionsWrapper = styled(StyledActionsWrapper)`
  &&& {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    padding: 20px;
    z-index: 10;

    button {
      margin-left: 0;
      margin-right: 8px;
    }
  }
`

export const StyledPhasingOutContent = styled.div`
  background: #fff7f0;
  padding: 16px;
  font-size: 14px;
  display: flex;
`

export const StyledTextForDisposedParcel = styled(Text)`
  && {
    overflow: hidden;
    text-overflow: ellipsis;
    height: 100%;
    width: ${({ width }) => width}px;
    white-space: nowrap;
    padding-top: 14px;
  }
`

export const StyledUpperCasedText = styled(Text)`
  && {
    text-transform: uppercase;
  }
`

export const StyledSimpleButton = styled(Button)`
  margin-left: 8px;
`

export const StyledBackToSubmittedForFulfillmentButton = styled(Button)`
  && {
    width: 382px;
    text-transform: none;
    margin: 0;
  }
  ${({ success }) =>
    success &&
    ` &&& {
      background-color: ${Colors.cherryRed};
      color: ${Colors.white};
      :hover {
        color: ${Colors.white};
        opacity: 0.8;
      }
    }
  `}
`

export const StyledIconButton = styled(IconButton)`
  margin-right: 0;
`

export const StyledDrawer = styled(Drawer)`
  && {
    .ant-drawer-wrapper-body {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    .ant-drawer-body {
      height: 100%;
      padding: 0;
      overflow: hidden;
      position: relative;
      display: flex;
      flex-direction: column;
      background-color: ${Colors.lightGrey};
    }
    .ant-drawer-header {
      border: none;
      background-color: ${Colors.aliceBlue};
    }
    .ant-drawer-close {
      visibility: ${props => (props.hidecloseicon ? 'hidden' : 'visible')};
    }
  }
`
export const StyledContentWrapper = styled.div`
  height: 100%;
  background-color: ${props => (props.background ? props.background : Colors.white)};
  padding: 24px 24px 80px 24px;
  overflow-y: auto;
  flex: 1;
`

export const StyledCard = styled.div`
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 32px;
  color: #4c4c4c;
`

export const GreyStyledCard = styled.div`
  background: #f2f2f2;
  border-radius: 8px;
  padding: 4px 8px 8px;
  margin-bottom: 32px;
  min-width: 350px;
  text-align: left;
`

export const StyledDivider = styled.div`
  height: 1px;
  background: #e0e0e0;
  margin: -16px 0 0 0;
  border-radius: 1px;
`

export const PaddedLabel = styled.div`
  padding-left: 16px;
  margin-bottom: 8px;
`

export const ScrollableContent = styled.div`
  overflow-y: auto;
  flex: 1;
  height: calc(100% - 40px);
  
  /* Webkit browsers (Chrome, Safari, Edge) */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${Colors.paleGrey};
    border-radius: 3px;
    
    &:hover {
      background: ${Colors.greyishBrown};
    }
  }
  
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: ${Colors.paleGrey} transparent;
  
  /* Hide scrollbar for mobile devices */
  @media (max-width: 768px) {
    &::-webkit-scrollbar {
      width: 0;
    }
    scrollbar-width: none;
  }
`